import {
  OPERATOR_TYPES_6,
} from './operators';

const OPERATOR_TYPES_1 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
];

const OPERATOR_TYPES_2 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'does_not_contain',
    label: 'Does not contain',
  },
];
const OPERATOR_TYPES_4 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_greater_than',
    label: 'Is greater than',
  },
  {
    value: 'is_lesser_than',
    label: 'Is lesser than',
  },
  {
    value: 'greater_than_equals_to',
    label: 'Greater than equal to',
  },
  {
    value: 'less_than_equals_to',
    label: 'Lesser than equal to',
  },
];

const OPERATOR_TYPES_3 = [
  {
    value: 'equal_to',
    label: 'Equal to',
  },
  {
    value: 'not_equal_to',
    label: 'Not equal to',
  },
  {
    value: 'is_present',
    label: 'Is present',
  },
  {
    value: 'is_not_present',
    label: 'Is not present',
  },
];



export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'Message Type',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
        ],
      },
      {
        key: 'content',
        name: 'Message Content',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'conversation_status',
        name: 'Conversation Status',
        attributeI18nKey: 'CONVERSATION_STATUS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_status',
        name: 'Contact Status',
        attributeI18nKey: 'CONTACT_STATUS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Contact Inbox',
        attributeI18nKey: 'INBOX_ID',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      // add more 2
      {
        key: 'conversation_type',
        name: 'Conversation Type',
        attributeI18nKey: 'CONVERSATION_TYPE',
        inputType: 'search_select',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
        ],
      },
      {
        key: 'message_recipient',
        name: 'Message Recipient',
        attributeI18nKey: 'MESSAGE_RECIPIENT',
        inputType: 'search_select',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
        ],
      }


    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
      {
        key: 'set_contact_attributes',
        label: 'Set Contact Attributes',
      },
      {
        key: 'assign_bot',
        label: 'Assign a bot',
      },
      {
        key: 'change_contact_status',
        label: 'Set Contact Status',
      },
      {
        key: 'trigger_event',
        label: 'Trigger a event',
      },
    ],
  },
  event_created: {
    conditions: [
      {
        key: 'status_id',
        name: 'Status',
        attributeI18nKey: 'STATUS_ID',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'event_name',
        name: 'Event Name',
        attributeI18nKey: 'EVENT_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'custom_event',
        name: 'Custom Event',
        attributeI18nKey: 'CUSTOM_EVENT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
    ],
    actions: [
      {
        key: 'assign_bot',
        label: 'Assign a bot',
      },
      {
        key: 'trigger_event',
        label: 'Trigger a event',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
    ],
  },
  message_updated: {
    conditions: [
      {
        key: 'message_type',
        name: 'Message Type',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
        ],
      },
      {
        key: 'content',
        name: 'Message Content',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'status',
        name: 'Message Status',
        attributeI18nKey: 'MESSAGE_STATUS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'set_contact_attributes',
        label: 'Set Contact Attributes',
      },
      {
        key: 'change_contact_status',
        label: 'Set Contact Status',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },

      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referrer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'labels',
        name: 'Label',
        attributeI18nKey: 'LABEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_status',
        name: 'Contact Status',
        attributeI18nKey: 'CONTACT_STATUS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_2,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'set_contact_attributes',
        label: 'Set Contact Attributes',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSERnego_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'labels',
        name: 'Label',
        attributeI18nKey: 'LABEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_status',
        name: 'Contact Status',
        attributeI18nKey: 'CONTACT_STATUS',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_2,
      },
    ],
    actions: [
      {
        key: 'set_contact_attributes',
        label: 'Set Contact Attributes',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        label: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        label: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        label: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        label: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        label: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        label: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        label: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        label: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        label: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        label: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  contact_created: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'name',
        name: 'Name',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'status_id',
        name: 'Status',
        attributeI18nKey: 'STATUS_ID',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
      {
        key: 'set_contact_attributes',
        label: 'Set Contact Attributes',
      },
      // {
      //   key: 'send_email_to_team',
      //   name: 'Send an email to team',
      //   attributeI18nKey: 'SEND_MESSAGE',
      // },
    ],
  },
  contact_updated: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'status_id',
        name: 'Status',
        attributeI18nKey: 'STATUS_ID',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'name',
        name: 'Name',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
      // {
      //   key: 'send_email_to_team',
      //   name: 'Send an email to team',
      //   attributeI18nKey: 'SEND_MESSAGE',
      // },
    ],
  },
  contact_attribute_changed: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'status_id',
        name: 'Status',
        attributeI18nKey: 'STATUS_ID',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'name',
        name: 'Name',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
      {
        key: 'assign_bot',
        label: 'Assign a bot',
      }
      // {
      //   key: 'send_email_to_team',
      //   name: 'Send an email to team',
      //   attributeI18nKey: 'SEND_MESSAGE',
      // },
    ],
  },
  form_responder_completed: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'status_id',
        name: 'Status',
        attributeI18nKey: 'STATUS_ID',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'name',
        name: 'Name',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ],
    actions: [
      {
        key: 'assign_team',
        label: 'Assign a team',
      },
      {
        key: 'add_label',
        label: 'Add a label',
      },
      {
        key: 'send_message',
        label: 'Send A Message',
      },
      {
        key: 'assign_bot',
        label: 'Assign a bot',
      }
    ],
  },
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'Conversation Created',
  },
  {
    key: 'conversation_updated',
    value: 'Conversation Updated',
  },
  {
    key: 'message_created',
    value: 'Message Created',
  },
  {
    key: 'message_updated',
    value: 'Message Updated',
  },
  {
    key: 'contact_created',
    value: 'Contact Created',
  },
  {
    key: 'contact_updated',
    value: 'Contact Updated',
  },
  {
    key: 'contact_attribute_changed',
    value: 'Contact Attribute Changed',
  },
  {
    key: 'event_created',
    value: 'Event Created',
  },
  {
    key: 'form_responder_completed',
    value: 'Form Responder Completed',
  }
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'Assign to agent',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'Assign a team',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'Add a label',
    inputType: 'multi_select',
  },
  {
    key: 'send_message',
    label: 'Send A Message',
    inputType: 'textarea',
  },
  {
    key: 'change_contact_status',
    label: 'Set Contact Status',
    inputType: null,
  },
  {
    key: 'assign_bot',
    label: 'Assign a bot',
    inputType: 'search_select',  // for inbox list select, also keep a textinput for bot_id
  },
  {
    key: 'set_contact_attributes',
    label: 'Set Contact Attributes',
    inputType: 'multi_select',
  },
  // {
  //   key: 'send_email_to_team',
  //   label: 'Send an email to team',
  // },
  {
    // _._
    key: 'trigger_event',
    label: 'Triger event',
    inputType: 'text',
  },
];

export const CUSTOM_ATTRIBUTES_DATA = [
  {
    key: 'email',
    name: 'Email',
  },
  {
    key: 'name',
    name: 'Name',
  },
  {
    key: 'phone_number',
    name: 'Phone Number',
  },
  {
    key: 'status',
    name: 'Status',
  },
];
